import "assets/scss/logs.scss";
import { useState } from "react";
import { Toaster } from "react-hot-toast";

import { SealsTab } from "components/logs/tabs/SealLogs";
import { UpdatesTab } from "components/logs/tabs/UpdatesTab";
import OldOrders from "views/OldOrders.js"

export const LogsMainView = () => {
    const [tab, setTab] = useState("Orders");

    const tabs = [
        { name: "Orders", icon: "fa fa-box" },
        { name: "Seals", icon: "fa fa-lock" },
        { name: "Updates", icon: "fa fa-sync" },
    ]

    return (
        <>
            <div className="warehouse-main-section-buttons-wrapper mb-3">
                <div className="col mx-0 px-0">
                    {
                        tabs.map((tabItem) => (
                            <button
                                key={tabItem.name}
                                className={`warehouse-main-header ${tab === tabItem.name ? "warehouse-active" : ""}`}
                                onClick={() => setTab(tabItem.name)}
                            >
                                <i className={tabItem.icon}></i> {tabItem.name}
                            </button>
                        ))
                    }
                </div>
            </div>
            <div className="warehouse-main-section">
                {tab === "Orders" && <OldOrders />}
                {tab === "Seals" && <SealsTab />}
                {tab === "Updates" && <UpdatesTab />}
            </div>

            <Toaster position="bottom-right" />
        </>
    );
};
